import { render, staticRenderFns } from "./AdditionBar.vue?vue&type=template&id=210cf36c&scoped=true&"
import script from "./AdditionBar.vue?vue&type=script&lang=js&"
export * from "./AdditionBar.vue?vue&type=script&lang=js&"
import style0 from "./AdditionBar.vue?vue&type=style&index=0&id=210cf36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210cf36c",
  null
  
)

export default component.exports